import { Suspense, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router"
import { Plus } from "@phosphor-icons/react"
import { DrawerWrapper } from "@/components/drawer-wrapper"
import { Button } from "@/components/ui/button"
import { Header } from "@/layouts/header"
import { SearchBox } from "@/modules/admin/treatment/components/search-box"
import { TreatmentTable } from "@/modules/admin/treatment/components/treatment-table"
import { useTreatmentQueryLoader } from "@/modules/admin/treatment/services/useTreatmentQuery"

const MyTreatmentPlanTemplates = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [queryRef, loadQuery] = useTreatmentQueryLoader()
  const [keyword, setKeyword] = useState("")

  const onClickCreateTreatment = () => {
    navigate("new")
  }

  useEffect(() => {
    loadQuery({}, { fetchPolicy: "network-only" })
  }, [loadQuery])

  return (
    <>
      <Header title={t(`admin.treatment.pageTitle.owner`)}>
        <Button className="pl-4" data-testid="patient-create-button" onClick={onClickCreateTreatment}>
          <Plus size={24} />
          {t("admin.treatment.treatmentPlan")}
        </Button>
      </Header>
      <div className="grid-cols-1fr-auto bg-background-subdued grid px-8" data-testid="treatment-page">
        <div className="grid-rows-auto-1fr grid pt-8">
          <div className="flex items-center gap-8">
            <SearchBox className="ml-auto" value={keyword} onChange={setKeyword} onClear={() => setKeyword("")} />
          </div>
          <div className="grid-rows-1fr mt-8 grid">
            <Suspense fallback={null}>{queryRef && <TreatmentTable queryRef={queryRef} keyword={keyword} />}</Suspense>
          </div>
        </div>
        <DrawerWrapper containerId="prevention-programs-drawer" />
      </div>
    </>
  )
}

export { MyTreatmentPlanTemplates }
